import React from 'react'

const SVGFlags = ({ countryCode, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='2 9 44 30'
      {...props}
      style={{
        backgroundColor: /AT|CH|DE|IT/.test(countryCode)
          ? 'transparent'
          : 'black'
      }}>
      {countryCode === 'AT' && (
        <g>
          <rect x='2' y='9' fill='#FF3D00' width='44' height='30' />
          <rect x='2' y='19' fill='#ECEFF1' width='44' height='10' />
        </g>
      )}
      {countryCode === 'CH' && (
        <g>
          <rect x='2' y='9' fill='#FF3D00' width='44' height='30' />
          <g>
            <rect x='21' y='15' fill='#FFFFFF' width='6' height='18' />
            <rect x='15' y='21' fill='#FFFFFF' width='18' height='6' />
          </g>
        </g>
      )}
      {countryCode === 'DE' && (
        <g>
          <rect x='2' y='29' fill='#FFC107' width='44' height='10' />
          <rect x='2' y='19' fill='#FF3D00' width='44' height='10' />
          <rect x='2' y='9' fill='#455A64' width='44' height='10' />
        </g>
      )}
      {countryCode === 'IT' && (
        <g>
          <rect x='16' y='9' fill='#ECEFF1' width='16' height='30' />
          <rect x='32' y='9' fill='#FF3D00' width='14' height='30' />
          <rect x='2' y='9' fill='#689F38' width='14' height='30' />
        </g>
      )}
      {!/AT|CH|DE|IT/.test(countryCode) && (
        <text
          style={{ font: 'bold 21px sans-serif', fill: 'white' }}
          x={8}
          y={30}
          textLength={30}>
          {countryCode}
        </text>
      )}
    </svg>
  )
}

export default SVGFlags
